import type { BaseRouteType, BaseMethodType } from '../types.ts'
import { z } from "zod";
export const tagsGetAdminClients_municipalityIdData_importTemplates = z.any()
export type TagsGetAdminClients_municipalityIdData_importTemplates = z.infer<typeof tagsGetAdminClients_municipalityIdData_importTemplates>

export const paramsGetAdminClients_municipalityIdData_importTemplates = z.object({ "municipalityId": z.string().uuid() })
export type ParamsGetAdminClients_municipalityIdData_importTemplates = z.infer<typeof paramsGetAdminClients_municipalityIdData_importTemplates>

export const responseGetAdminClients_municipalityIdData_importTemplates = z.object({ "payload": z.object({ "templates": z.array(z.object({ "kind": z.union([z.literal("readings"), z.literal("invoices")]), "filename": z.string(), "csv": z.string(), "variant": z.union([z.literal("existing"), z.literal("new")]).optional(), "xlsx": z.string().optional(), "columns": z.array(z.object({ "header": z.string(), "description": z.string() })) })) }).optional(), "errors": z.any(), "message": z.string().optional() })
export type ResponseGetAdminClients_municipalityIdData_importTemplates = z.infer<typeof responseGetAdminClients_municipalityIdData_importTemplates>

interface IGetAdminClients_municipalityIdData_importTemplates extends BaseMethodType {
  tags: TagsGetAdminClients_municipalityIdData_importTemplates,
  params: ParamsGetAdminClients_municipalityIdData_importTemplates,
  response: ResponseGetAdminClients_municipalityIdData_importTemplates
}
export const URL = '/admin/clients/:municipalityId/data-import/templates'
export const validation = {
  get: {
    tags: tagsGetAdminClients_municipalityIdData_importTemplates,
    params: paramsGetAdminClients_municipalityIdData_importTemplates,
    response: responseGetAdminClients_municipalityIdData_importTemplates
  }
}
export interface AdminClients_municipalityIdData_importTemplates extends BaseRouteType {
  get: IGetAdminClients_municipalityIdData_importTemplates
}